import React from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle,SocialMediaIcons,SocialMediaIcon, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/HeroImage.jpg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import {Tilt} from 'react-tilt'

const HeroSection = () => {
    return (
        <div>
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{Bio.description}</SubTitle>

                        {/* this is the resume button that will open the resume. */}
                        {/* <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton> */} 

                        
                        <ResumeButton href={Bio.phone} target='display'>Contact Me</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <Tilt>
                            
                        <Img src={HeroImg} alt="hero-image" />
                                    </Tilt>
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
        </div>
    )
}

export default HeroSection